import Vue from 'vue'
import Component from 'vue-class-component'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import _ from 'lodash'
import {Prop} from 'vue-property-decorator';
import Widget from '@/modules/widget/model/Widget';


/**
 * Mixin con funciones de utilidad para crear Widgets
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class WidgetMixin extends Vue {
    /**
     * El identificador del Widget que será cargado
     */
    @Prop({type: Number, required: true})
    public value: number

    public get widget (): Widget {
        return this.$store.getters['widget/widget'](this.value)
    }

    /**
     * Permite acceder a una propiedad del estado del widget
     *
     * @param path
     * @param _default
     */
    public get (path: string, _default: any = null) {
        return _.get(this.widget.state, path, _default)
    }

    /**
     * Establece un campo y su valor en el estado del widget
     *
     * @param path Nombre de la propiedad a insertar en el objeto del estado
     * @param value Valor que almacenará la propiedad
     */
    public set (path: string, value: any) {
        this.$store.commit('widget/UPDATE_WIDGET_STATE', {
            widget: this.widget.id,
            path, value,
        })
    }

    /**
     * Guarda en el servidor los cambios realizados en el estado del widget
     */
    public async syncState () {
        await this.$store.dispatch('widget/updateWidgetState', this.widget.id)
    }
}

